import { withTranslation } from "react-i18next";
import React, { Component } from "react";
import Footer from "../../../components/Footer";
import Carousel from "../components/Carousel";
import "../styles.css";
import { config } from "../../../config";
import BikeFitPromo from "../components/BikefitPromo";
import DocumentMeta from "react-document-meta";
import i18next from "i18next";
import Locale from "../../../lib/Locale";

class MTBHome extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.startSlider = this.startSlider.bind(this);
    this.moveRight = this.moveRight.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.startSlider();
    var self = this;
    setInterval(function () {
      self.moveRight();
    }, 1000);
  }
  render() {
    const meta = {
      title: this.props.t("MTBHome_Title"),
      description: this.props.t("MTBHome_AnswerAQuestion"),
    };
    return (
      <div>
        <DocumentMeta {...meta} />
        <div
          className={
            i18next.language === "nl_NL"
              ? "jumbotron-fluid jumbo-image"
              : "jumbotron-fluid jumbo-image-en"
          }
        >
          <div className="container-fluid">
            <h1>{this.props.t("MTBHome_Title")}</h1>
            <p className="lead sub">
              {this.props.t("MTBHome_AnswerAQuestion")}
            </p>
            <div className="my-4">&nbsp;</div>
            <p className="lead">
              <a
                className="btn btn-primary btn-lg"
                href={Locale.getUrlForCurrentLocale("/mtb/advice/experience")}
                role="button"
              >
                {this.props.t("MTBHome_StartAdvice")}
              </a>
              <button className="btn btn-lg btn-default to_info">
                {this.props.t("MTBHome_WhyFrameFit")}
              </button>
            </p>
            <ul className="list-inline">
              <li className="list-inline-item">
                {this.props.t("MTBHome_PersonalAdvice")}
              </li>
              <li className="list-inline-item">
                {this.props.t("MTBHome_CompareAllMTB")}
              </li>
              <li className="list-inline-item">
                {this.props.t("MTBHome_Transparent")}
              </li>
            </ul>
          </div>
        </div>
        <BikeFitPromo dark={false} mtb={true} />

        <div className="seo-intro-container py-4">
          <div className="container text-center">
            <h2>
              {this.props.t(
                "Alle ins en outs over het kopen van jouw mountainbike"
              )}
            </h2>
            <p>
              {this.props.t("InfoMountainbikes-nieuwe mountainbike te kopen?")}
            </p>
          </div>
        </div>

        <div className="container text-center">
          <div className="row justify-content-center align-items-center">
            <div id="framefit_info" className="col-sm-12 framefit_info">
              <header className="prime_title">
                <h2>{this.props.t("MTBHome_PeronalTransparent")}</h2>
              </header>
            </div>
          </div>
          <div className="row justify-content-center align-items-center home-row">
            <div className="col-sm-6 align-middle">
              <h3>{this.props.t("MTBHome_AdviceForYou")}</h3>
              <p>{this.props.t("MTBHome_WeThink")}</p>
            </div>

            <div className="col-sm-6 text-center">
              <div className="home-column-inner">
                <img
                  className="img-responsive"
                  src={
                    i18next.language === "nl_NL"
                      ? "/img/silhouette/Mountainbike-fietsmaat.png"
                      : "/img/silhouette/Mountain-bike-frame-size.png"
                  }
                  alt={this.props.t("MBT_Size")}
                />
              </div>
            </div>
          </div>
          <div className="row justify-content-center align-items-center home-row">
            <div className="col-sm-6 order-12">
              <h3>{this.props.t("MTBHome_CompareBrands")}</h3>
              <p>{this.props.t("MTBHome_WeCompare")}</p>
            </div>
            <div className="col-sm-6 text-center order-1">
              <div className="home-column-inner slider">
                <Carousel type="mtb" />
              </div>
            </div>
          </div>
          <div className="row justify-content-center align-items-center home-row">
            <div className="col-sm-6">
              <h3>{this.props.t("MTBHome_TransparentTopThree")}</h3>
              <p>{this.props.t("MTBHome_WeGiveAdvice")}</p>
            </div>

            <div className="col-sm-6 text-center">
              <div className="home-column-inner">
                <img
                  className="img-responsive"
                  src={
                    i18next.language === "nl_NL"
                      ? "/img/Mountainbike-vergelijken-voorbeeld.png"
                      : "/img/Mountain-bike-comparison-example.png"
                  }
                  alt={this.props.t("MBT_Advies")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="framefit_info">
          <div className="dark-section">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <header className="prime_title">
                    <h2>{this.props.t("MTBHome_PrimeTitle")}</h2>
                  </header>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <h3>
                    {this.props.t("MTBHome_ExperienceAndAdvice")}{" "}
                    <i className="fas fa-caret-right"></i>
                  </h3>

                  <p>{this.props.t("MTBHome_WithTheHelpOf")}</p>
                </div>

                <div className="col-sm-4">
                  <h3>
                    {this.props.t("MTBHome_Sizes")}{" "}
                    <i className="fas fa-caret-right"></i>
                  </h3>

                  <p>{this.props.t("MTBHome_BasedOn")}.</p>
                </div>

                <div className="col-sm-4">
                  <h3>{this.props.t("MTBHome_Advice")}</h3>

                  <p>{this.props.t("MTBHome_Compare")}.</p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3"></div>
                <div className="col-sm-6">
                  <video
                    controls
                    ref="vidRef"
                    poster="/img/poster-default.png"
                    src={
                      i18next.language === "nl_NL"
                        ? require("../video/Mountainbike-kopen-advies.mp4")
                        : require("../video/Mountain-bike-buying-advice.mp4")
                    }
                    type="video/mp4"
                  ></video>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            i18next.language === "nl_NL"
              ? "section-new-mtb framefit_info"
              : "section-new-mtb-en framefit_info"
          }
        >
          <div className="container-fluid">
            <h3 className="display-4">{this.props.t("MTBHome_OtherBike")}?</h3>
            <p className="sub">{this.props.t("MTBHome_weAdvice")}</p>
            <hr className="my-2" />
            <p className="lead">
              <a
                className="btn btn-primary btn-lg"
                href={Locale.getUrlForCurrentLocale(config.raceUrl + "/road/advice/experience")}
                role="button"
              >
                {this.props.t("MTBHome_StartAdviceRace")}
              </a>
            </p>
          </div>
        </div>
        <div className="info-page ">
          <div className="container">
            <h2>
              {this.props.t(
                "Verschil van een mountainbike ten opzichte van andere fietsen"
              )}
            </h2>

            <p>
              {this.props.t("InfoMountainbikes-Mountainbikes zijn gemaakt om")}
            </p>

            <p>
              {this.props.t("InfoMountainbikes-De naam mountainbike is daarom")}
              :
            </p>

            <p>{this.props.t("InfoMountainbikes-Algemene kenmerken van")}</p>

            <p>{this.props.t("InfoMountainbikes-Naast de MTB bestaat")}</p>

            <h2>{this.props.t("Een mountainbike kopen")}</h2>

            <p>{this.props.t("InfoMountainbikes-Een mtb kopen")}</p>

            <p>
              {this.props.t("InfoMountainbikes-De belangrijkste onderdelen")}
            </p>

            <h2>{this.props.t("Mountainbike kopen advies")}</h2>

            <p>
              {this.props.t("InfoMountainbikes-Zoals hier boven aangegeven")}
            </p>

            <p>{this.props.t("InfoMountainbikes-In deze tool worden")}</p>

            <h2>
              {this.props.t("Wat is belangrijk aan een goede mountainbike?")}
            </h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-Er zijn heel veel mountainbikes"
              )}
            </p>

            <h2>{this.props.t("Type mountainbike")}</h2>

            <p>{this.props.t("InfoMountainbikes-De eerste keuze die je")}</p>

            <h3>{this.props.t("Cross country")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Bij de cross country mountainbike"
              )}
            </p>

            <p>
              {this.props.t("InfoMountainbikes-De meeste XC-mountainbikes")}
            </p>

            <h3>{this.props.t("Trail")}</h3>

            <p>
              {this.props.t("InfoMountainbikes-Trail Bikes zijn ontworpen als")}
            </p>

            <p>{this.props.t("InfoMountainbikes-Ben je op zoek naar")}</p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Vrijwel alle Trail Bikes hebben"
              )}
            </p>

            <h3>{this.props.t("Enduro")}</h3>

            <p>{this.props.t("InfoMountainbikes-De enduro mountainbike is")}</p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Er bestaat een aparte discipline"
              )}
            </p>

            <p>
              {this.props.t("InfoMountainbikes-De enduro mountainbike kan")}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-De enduro mountainbike is echter"
              )}
            </p>

            <h3>{this.props.t("Downhill")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Bij Downhill (ook wel Gravity genaamd)"
              )}
            </p>

            <p>{this.props.t("InfoMountainbikes-Bij Downhill draag je")}</p>

            <h3>{this.props.t("Fat bike")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Fat bikes hebben extreem brede banden"
              )}
            </p>

            <p>
              {this.props.t("InfoMountainbikes-De meeste Fat bikes hebben")}
            </p>

            <h2>{this.props.t("Veringopties")}</h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-De vering is een belangrijk onderdeel"
              )}
            </p>

            <h3>{this.props.t("Hardtail")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Hardtail mountainbikes komen veel"
              )}
            </p>

            <h3>{this.props.t("Fully")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Een fully, ook wel full suspension"
              )}
            </p>

            <p>{this.props.t("InfoMountainbikes-De nadelen van een fully")}</p>

            <h3>{this.props.t("Rigid")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Er zijn maar enkele mountainbikes zonder"
              )}
            </p>

            <h2>{this.props.t("Materialen")}</h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-De meeste mountainbikes zijn gemaakt"
              )}
            </p>

            <h3>{this.props.t("Staal")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Vroeger werden vrijwel alle mountainbikes"
              )}
            </p>

            <h3>{this.props.t("Aluminium")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Aluminium is het meest gebruikte materiaal"
              )}
            </p>

            <h3>{this.props.t("Carbon")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Carbon zorgt voor de ideale combinatie"
              )}
            </p>

            <h3>{this.props.t("Titanium")}</h3>

            <p>
              {this.props.t("InfoMountainbikes-Titanium frames zijn erg duur")}
            </p>

            <h2>{this.props.t("Maat")}</h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-Een van de belangrijkste aspecten"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-In de fietsbranche wordt vaak een"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Twee personen van dezelfde lengte"
              )}
            </p>

            <p>
              {this.props.t("InfoMountainbikes-Een framemaat is gebaseerd op")}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-De reach is de horizontale afstand"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-De stack is de verticale afstand"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Het kiezen van de juiste framemaat"
              )}
            </p>

            <h2>{this.props.t("Afmontage van de mountainbike")}</h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-De kwaliteit van een mountainbike"
              )}
            </p>

            <h3>{this.props.t("Wielmaat")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-Naast de framemaat speelt de maat"
              )}
            </p>

            <ul>
              <li>
                <strong>{this.props.t("29 inch wielen")}</strong>{" "}
                {this.props.t("InfoMountainbikes-zijn ideaal voor als je snel")}{" "}
              </li>
              <li>
                <strong>{this.props.t("27.5 inch wielen")}</strong>{" "}
                {this.props.t("InfoMountainbikes-zijn de beste keuze wanneer")}
                <ul>
                  <li>
                    {this.props.t("InfoMountainbikes-Het stuur bij een mtb")}
                  </li>
                  <li>
                    {this.props.t(
                      "InfoMountainbikes-Je een speelse en wendbare"
                    )}
                  </li>
                  <li>
                    {this.props.t(
                      "InfoMountainbikes-Je ruige afdalingen wilt gaan"
                    )}
                  </li>
                </ul>
              </li>
              <li>
                <strong>{this.props.t("26 inch wielen")}</strong>{" "}
                {this.props.t(
                  "InfoMountainbikes-worden nauwelijks gebruikt bij nieuwe"
                )}
              </li>
            </ul>

            <h3>{this.props.t("Versnellingsgroep")}</h3>

            <p>
              {this.props.t("InfoMountainbikes-Een mountainbike is net als")}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Het aantal versnellingen wordt vooral"
              )}
            </p>

            <p>
              {this.props.t("InfoMountainbikes-De overbreng verhoudingen of")}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Over het algemeen kun je stellen dat"
              )}
            </p>

            <h3>{this.props.t("Remmen")}</h3>

            <p>
              {this.props.t(
                "InfoMountainbikes-De meeste mountainbikes zijn voorzien"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Over het algemeen kun je stellen"
              )}
            </p>

            <h2>{this.props.t("Prijs")}</h2>

            <p>
              {this.props.t("InfoMountainbikes-Natuurlijk speelt jouw budget")}
            </p>

            <ul>
              <li>{this.props.t("InfoMountainbikes-Spring of Air vering")} </li>
              <li>
                {this.props.t(
                  "InfoMountainbikes-Velgremmen, mechanische schijfremmen"
                )}
              </li>
              <li>
                {this.props.t("InfoMountainbikes-Geen vering, voorvering of")}
              </li>
              <li>
                {this.props.t("InfoMountainbikes-Aluminium of carbon frame")}
              </li>
              <li>
                {this.props.t(
                  "InfoMountainbikes-Kwaliteit en gewicht van de wielen"
                )}
              </li>
              <li>
                {this.props.t(
                  "InfoMountainbikes-Kwaliteit van het schakelsysteem en de aandrijving"
                )}
              </li>
            </ul>

            <h2>{this.props.t("Dames en heren mountainbikes")}</h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-Vroeger was er enkel de mountainbike voor heren"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Sommige merken claimen ook dat vrouwen"
              )}
            </p>

            <h2>{this.props.t("Verschil ATB en MTB")}</h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-Zoals eerder beschreven, zit er een verschil tussen een ATB fiets en een MTB fiets"
              )}
            </p>

            <h2>{this.props.t("Andere optie een mountainbike huren")}</h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-Ben je niet zeker van je investering in een mountainbike?"
              )}
            </p>

            <h2>{this.props.t("Ideale zithouding fiets mountainbike")}</h2>

            <p>
              {this.props.t(
                "InfoMountainbikes-De optimale zithouding op een mountainbike is persoonlijk"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-Als je van plan bent om een nieuw fiets"
              )}
            </p>

            <p>
              {this.props.t(
                "InfoMountainbikes-In ons Bikefit advies stellen wij diverse vragen"
              )}
            </p>
          </div>
        </div>
        <Footer t={this.props.t} />
      </div>
    );
  }

  startSlider() {
    var slideCount = window.$("#slider ul li").length;
    var slideWidth = window.$("#slider ul li").width() * 2 + 75;
    var slideHeight = window.$("#slider ul li").height();
    var sliderUlWidth = slideCount * slideWidth;

    window.$("#slider").css({ height: slideHeight });

    window
      .$("#slider ul")
      .css({ width: sliderUlWidth, marginLeft: -slideWidth });

    window.$("#slider ul li:last-child").prependTo("#slider ul");
  }

  moveRight() {
    var slideWidth = window.$("#slider ul li").width();
    window.$("#slider ul").animate(
      {
        left: -slideWidth,
      },
      1000,
      function () {
        window.$("#slider ul li:first-child").appendTo("#slider ul");
        //window.$('#slider ul').css('left', '');
      }
    );
  }
}

export default withTranslation("homeMtb")(MTBHome);
